import { defineComponent, type FunctionalComponent } from 'vue'
import EmptyState from 'components/empty-state'
import InfoCircle from 'assets/img/svg/icons/info-circle.svg?url'
import Button from 'components/button'
import type { UseProviderImport } from '../../hooks/useProviderImport'

export const FinsquidMaintenance = defineComponent<{
  importAssets: UseProviderImport;
}>(
  (props) => {
    const loading = ref<boolean>(false)

    const EmptyStateAction: FunctionalComponent = () => {
      return (
        <Button
          isLoading={loading.value}
          onClick={async () => {
            loading.value = true
            await nextTick()
            await props.importAssets.reset();
            loading.value = false
          }}
        >
          Go Back
        </Button>
      )
    }

    return () => {
      return (
        <div class="w-full h-full flex flex-col items-center justify-center px-4 md:px-0">
          <EmptyState
            class="max-w-[430px]"
            title="Under Maintenance"
            subtitle="Provider connections are temporarily unavailable while we perform maintenance. Please try again later."
            icon={{
              src: InfoCircle,
              size: '2rem',
              fill: '#9CA3AF',
              stroke: 'current-color'
            }}
            action={() => <EmptyStateAction />}
          />
        </div>
      )
    }
  },
  { props: ['importAssets'] }
)
